/** Map completeness field paths to Profile section anchors. */
export function policyProfileSectionAnchor(path: string): string {
  if (path.startsWith("governance.")) return "policy-governance";
  if (path.startsWith("services.")) return "policy-services";
  if (path === "facility.home_care_license_level") return "policy-services";
  if (path === "facility.hcbs_support_level") return "policy-services";
  if (path.startsWith("medication_storage.")) return "policy-medication-storage";
  if (path.startsWith("forms.")) return "policy-forms";
  if (path.startsWith("public_funds.")) return "policy-public-funds";
  if (
    path.includes("director") ||
    path.includes("nurse") ||
    path.includes("privacy") ||
    path.includes("infection")
  ) {
    return "policy-roles";
  }
  if (
    path.includes("on_call") ||
    path.includes("emergency") ||
    path.includes("employee_health") ||
    path.includes("tb_referral")
  ) {
    return "policy-operations";
  }
  return "policy-identity";
}
